import React from "react";
import { CompanyAvatar, OverflowingTypography, Stack, Typography, } from "../components";
import { fileIconMap } from "@biggeo/bg-utils";
export const TooltipField = ({ field, content, fileType, }) => (React.createElement(Stack, null,
    React.createElement(Typography, { variant: "body4", textColor: "disabled.onContainer" }, field),
    fileType && content ? (React.createElement(Stack, { flexDirection: "row", gap: 1, alignItems: "center" },
        React.createElement(CompanyAvatar, { src: fileIconMap[fileType], size: "xxs", color: "background", sx: {
                borderColor: (theme) => theme.palette.stroke[100],
            } }),
        React.createElement(OverflowingTypography, { variant: "body4" }, content))) : (React.createElement(OverflowingTypography, { variant: "body4" }, content ? content : "-"))));
//# sourceMappingURL=TooltipField.js.map